import React, { Component, Dispatch } from 'react';

import './BasketItemBundle.scss';

import { BasketItemModel } from 'models/Basket';
import { formatCurrency } from 'formatters';
import { Loader, BasketSofashield } from 'components';
import {
    removeBasketItem,
    RemoveBasketItemFunc,
    removeSofashield,
    RemoveSofashieldFunc,
    updateSofashieldQuantity,
    UpdateSofashieldQuantityFunc
} from 'store/basket/actions';
import { connect } from 'react-redux';
import { generateDispatchToPropsMap } from 'helpers';

import { SofaItemOverview, SofaItemImage, SofaQuantity } from '@sofology/sofologycomponents';

interface OwnProps {
    basketItem: BasketItemModel;
    loading: boolean;
}

interface DispatchProps {
    removeBasketItem: RemoveBasketItemFunc;
    updateSofashieldQuantity: UpdateSofashieldQuantityFunc;
    removeSofashield: RemoveSofashieldFunc;
}

//  Any changes made here should be synced to BasketItem.tsx / ReadonlyItem.tsx / ReadonlyItemBundle.tsx
class BasketItemBundle extends Component<OwnProps & DispatchProps> {

    handleRemoveClick = () => {
        this.props.removeBasketItem(this.props.basketItem.product.code);
    };

    handleChangeSofashieldQuantity = (sku: string, sofashieldQuantity: number) => {
        this.props.updateSofashieldQuantity(sku, sofashieldQuantity);
    };

    handleSofashieldRemoveClick = (sku: string) => {
        this.props.removeSofashield(sku);
    };

    render(): JSX.Element {
        const { basketItem, loading } = this.props;

        return (
            <div className='basket-item-bundle'>
                <div className='basket-item-bundle__header'>
                    <div>{(basketItem.range ?? 'undefined') + ' bundle'} <div> in {basketItem.swatchColour}, {this.getBundleItemsCount()} items</div></div>
                    <a onClick={this.handleRemoveClick} className='basket-item-bundle__remove'>Remove</a>
                </div>
                {this.renderBasketContent()}
                <div className='basket-item-bundle__footer'>
                    <div>Bundle total</div>
                    <div className='basket-item-bundle__price'>
                        <div className='basket-item-bundle__price__now'>
                            {formatCurrency(basketItem.totalPrice.value, 0)}
                        </div>
                        <div className='basket-item-bundle__price__savings'>
                            <div className='basket-item-bundle__price__was'>
                                was <span>{formatCurrency(basketItem.totalPrice.value + basketItem.savingsPrice.value, 0)}</span>
                            </div>
                            <div className='basket-item-bundle__price__save'>
                                save {formatCurrency(basketItem.savingsPrice.value, 0)}
                            </div>
                        </div>
                    </div>
                </div>
                <Loader show={loading} overlay={true} />
                {
                    basketItem.sofashieldQuantity > 0
                    && <BasketSofashield
                        linkedSku={basketItem.product.code}
                        range={basketItem.range?.toLowerCase() ?? ''}
                        onChangeQuantity={this.handleChangeSofashieldQuantity}
                        onRemove={this.handleSofashieldRemoveClick}
                        optionsQuantity={basketItem.quantity}
                        sofashieldQuantity={basketItem.sofashieldQuantity}
                        loading={loading} />
                }
            </div>
        );
    }

    renderBasketContent(): JSX.Element {
        const { basketItem } = this.props;

        return (
            <div className='basket-item-bundle__content'>
                {basketItem.product.productReferences.map(productReference =>
                    <div className='basket-item-bundle__item' key={productReference.target.code}>
                        <SofaItemImage product={productReference.target} enableSofaLink={false} />
                        <div className='basket-item-bundle__item__details'>
                            <SofaItemOverview product={productReference.target} enableSofaLink={false} disableTitle={true} />
                            <div className='basket-item-bundle__item__controls'>
                                <SofaQuantity value={basketItem.quantity} hideControls={true} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    getBundleItemsCount = (): number => {
        return this.props.basketItem.product.productReferences
            .map(product => product.quantity)
            .reduce((sum, productQuantity) => sum + productQuantity);
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [removeBasketItem, updateSofashieldQuantity, removeSofashield]);
}

export default connect(undefined, mapDispatchToProps)(BasketItemBundle);